 export const skillsData = [
    'OpenAI',
    'Claude',
    'Anthropic',
    'LLMs',
    'MCP',
    'Prompt Engineering',
    'Node JS',
    'Javascript',
    'Typescript',
    'React',
    'Python',
    'AWS Services',
    'Docker',
    'Kubernetes',
    'Nginx',
    'Redis',
    'RabbitMQ',
    'Kafka',
    'MongoDB',
    'PostgreSQL',
    'MySQL',
    'GraphQL',
    'Git',
    'CICD',
    'Figma',
    'Vue',
    'Tailwind',
    'Bash Script',
    'New Relic',
    'Grafana'
]

// Choose your skills from below. Make sure it's in the same format and spelled correctly.
// Couldn't find the required skills? Raise an issue on github at https://github.com/praveenmistry/portfolio/issues/new


// AVAILABLE SKILLS

/* 
    HTML
    CSS
    JS 
    React
    Next JS
    Nuxt JS
    Node JS
    Vue
    Angular
    Docker
    Photoshop
    Illustrator
    Svelte
    GCP
    Azure
    Fastify
    Haxe
    Ionic
    Markdown
    Microsoft Office
    Picsart
    Sketch
    Unity
    WolframAlpha
    Adobe XD
    After Effects
    Bootstrap
    Bulma
    CapacitorJs
    Coffeescript
    MemSQL
    C
    C++
    C#
    Python
    Java
    Julia
    Matlab
    Swift
    Ruby
    Kotlin
    Go
    PHP
    Flutter
    Dart
    Typescript
    Swift
    Git
    Figma
    Canva
    Ubuntu
    Bootstrap
    MongoDB
    Tailwind
    ViteJS
    VuetifyJS
    MySQL
    PostgreSQL
    AWS
    Firebase
    Blender
    Premiere Pro
    Adobe Audition
    Deno
    Django
    Gimp
    Graphql
    Lightroom
    MaterialUI
    Nginx
    Numpy
    OpenCV
    Pytorch
    Selenium
    Strapi
    Tensorflow
    Webex
    Wordpress
    Redis
    Kafka
    Kubernetes
*/
